import React, { PropTypes, Component } from 'react';
import injectSheet from 'react-jss';
import { connect } from 'react-redux';
import pluralize from 'pluralize';

import {
  Card,
  CardHeader,
  CardText,
  FlatButton,
  FontIcon,
  TextField,
} from 'material-ui';
import AttachmentIcon from 'material-ui/svg-icons/file/attachment';


import Dropzone from '../../extra/dropzone/dropzone';
import UploadFromMM from '../../newsfeed/mainFeed/newPost/uploadFromMM';

import {
  resetSelectedRate,
  resetSelectedLocation,
  resetSelectedContractRequest as resetSelectedContractRequestFn,
} from '../../partner-details/__store__/actions';

const styles = {
  inputContainer: ({ borderless }) => ({
    border: borderless ? 'none' : '1px solid #bfbfbf',
    position: 'relative',
    '&.focused': {
      borderColor: '#00b3cf',
    },
  }),
  yellowBack: {
    backgroundColor: '#FFF5EA',
  },
  fileList: {
    paddingBottom: '1em',
    color: '#bfbfbf',
    fontSize: '12px',
    '&.hide': {
      visibility: 'hidden',
    },
    '& > .element': {
      backgroundColor: 'rgba(0, 126, 255, 0.6)',
      borderRadius: '2px',
      border: '1px solid rgba(0, 126, 255, 0.24)',
      color: '#fff',
      display: 'inline-block',
      fontSize: '0.9em',
      lineHeight: '1.4',
      marginLeft: '5px',
      marginTop: '5px',
      verticalAlign: 'top',
      '& > .remove': {
        cursor: 'pointer',
        borderBottomLeftRadius: '2px',
        borderTopLeftRadius: '2px',
        borderRight: '1px solid rgba(0, 126, 255, 0.24)',
        padding: '1px 5px 3px',
        display: 'inline-block',
        verticalAlign: 'middle',
      },
      '& > .text': {
        color: '#fff',
        textDecoration: 'none',
        borderBottomRightRadius: '2px',
        borderTopRightRadius: '2px',
        cursor: 'default',
        padding: '2px 5px',
        display: 'inline-block',
        verticalAlign: 'middle',
      },
    },
  },
  dropZone: {
    padding: '0 8px 0',
    color: '#bfbfbf',
    fontSize: '12px',
    clear: 'both',
  },
  inputZone: {
    display: 'flex',
    justifyContent: 'flex-start',
    minHeight: '80px',
    overflow: 'hidden',
    padding: '0 0 4px 12px',
  },
  dropZone2: {
    borderTop: '1px dotted #bfbfbf',
    clear: 'both',
    color: '#bfbfbf',
    fontSize: '12px',
    minHeight: '60px',
    padding: '12px 8px',
  },
  actionSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  attachmentButtons: {
    flex: '1 1 auto',
  },
  attachmentCard: {
    backgroundColor: 'transparent',
    borderBottom: '1px solid #e0e0e0',
    boxShadow: 'none',
  },
  attachmentHeaderText: {
    display: 'inline-block',
    overflow: 'hidden',
    fontSize: '16px',
    color: 'rgba(0, 0, 0, 0.54)',
    marginLeft: '15px',
  },
  actionButtons: {
    textAlign: 'right',
    marginBottom: '10px',
    '&.hide': {
      display: 'none',
    },
  },
  inputIcon: {
    top: '12px',
    flex: '0 0 auto',
  },
  textField: ({ hideMesageBoxIcon }) => ({
    flex: '1 1 auto',
    marginLeft: hideMesageBoxIcon ? '' : '10px',
    marginRight: '12px',
    maxHeight: '40vh',
    overflowY: 'auto',
  }),
  selectTemplate: {
    marginLeft: '2em',
  },
  sendContractButton: {
    margin: '2em',
  },
  rateSendBar: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  rateSendError: {
    color: '#ff4081',
  },
};

const defaultState = {
  attachmentExpanded: false,
  filesMM: [],
  filesUploaded: [],
  MMExpanded: false,
  rates: [],
  rateErrorMessage: '',
  rateValid: false,
};

// const isOverlapping = (startDate1, endDate1, startDate2, endDate2) => {
//   return moment(startDate1).isSameOrBefore(endDate2)
//   && moment(startDate2).isSameOrBefore(endDate1);
// };

class CommentBox extends Component {
  constructor(props) {
    super(props);
    this.state = defaultState;
  }
  componentDidMount() {
    this.props.setClear(this.clearAttachments);
  }
  clearAttachments = () => {
    this.setState(defaultState);
    this.clearMM();
  }
  updateFileList = (type) => {
    return (files) => {
      // filesUploaded only returns the files to attach
      const newFiles = type === 'filesUploaded' ? this.state[type].concat(files) : files.map(({
        name, url, size, mediaType,
      }) => ({
        fileName: name,
        name,
        url,
        path: url,
        size: ~~(parseFloat(size) * 1024),
        type: mediaType,
      }));
      this.setState({ [type]: newFiles }, () => {
        const { filesUploaded, filesMM } = this.state;
        this.props.attachFile([...filesUploaded, ...filesMM]);
        if ((filesUploaded.length + filesMM.length) > 0) {
        }
      });
    };
  }
  removeAfile = (type) => {
    return (fileIndex) => {
      const nuArray = [...this.state.filesUploaded];
      nuArray.splice(fileIndex, 1);
      this.setState({ [type]: nuArray }, () => {
        const { filesUploaded, filesMM } = this.state;
        this.props.attachFile([...filesUploaded, ...filesMM]);
      });
    };
  }
  render() {
    const {
      cancelComment,
      classes,
      className,
      comment,
      disableSend,
      focused,
      handleInput,
      hideActions,
      hideMesageBoxIcon,
      hintText,
      internal,
      setFocus,
      submitComment,
    } = this.props;
    const {
      attachmentExpanded,
      filesMM,
      filesUploaded,
    } = this.state;
    const addYellow = () => (internal ? ` ${classes.yellowBack}` : '');
    const allFilesCount = filesUploaded.concat(filesMM).length;
    return (
      <div className={className}>
        <div className={`${classes.inputContainer}${focused ? ' focused' : ''}${addYellow()}`}>
          <label htmlFor="commentBoxTextField">
            <Dropzone
              className={`${classes.dropZone}${addYellow()}`}
              onDrop={this.updateFileList('filesUploaded')}
              disableClick
            >
              <div className={classes.inputZone}>
                { !hideMesageBoxIcon
                  && <FontIcon className={`${classes.inputIcon}${internal ? ' tc-icon-note_add' : ' tc-icon-question_answer'}`} color="#bfbfbf" />
                }
                <TextField
                  id="commentBoxTextField"
                  hintText={hintText || (internal ? 'Add an Internal Note' : 'Type a Message')}
                  hintStyle={{ fontSize: '14px' }}
                  underlineShow={false}
                  value={comment || ''}
                  onInput={({ target: { value } }) => handleInput(value)}
                  onFocus={() => setFocus(true)}
                  onBlur={() => setFocus(false)}
                  multiLine
                  disabled={disableSend}
                  className={classes.textField}
                />
              </div>
            </Dropzone>
          </label>
          {
            !hideActions && (
              <div className={`${classes.actionButtons}${Boolean(comment || allFilesCount > 0) ? '' : ' hide'}`}>
                <FlatButton label="cancel" primary style={{ marginRight: '12px' }} onTouchTap={() => cancelComment('')} disabled={disableSend} />
                <FlatButton label={internal ? 'add' : 'send'} disabled={disableSend} labelStyle={(disableSend ? {} : { color: '#00b3cf' })} onTouchTap={() => submitComment()}/>
              </div>
            )
          }
          <div className={classes.attachmentButtons}>
            <Card
              expanded={attachmentExpanded}
              onExpandChange={(newExpadedState) => this.setState({ attachmentExpanded: newExpadedState })}
              style={styles.attachmentCard}
            >
              <CardHeader
                textStyle={{ display: 'none' }}
                {...{ showExpandableButton: true, actAsExpander: true }}
              >
                <FontIcon>
                  <AttachmentIcon color={'rgba(0, 0, 0, 0.54)'} style={{ verticalAlign: 'bottom', transform: 'rotate(-90deg)' }} />
                  <div className={classes.attachmentHeaderText}>
                    Attachments{!attachmentExpanded && filesUploaded.length > 0 ? <span style={{ color: '#00bcd4' }}>{` - ${filesUploaded.length} ${pluralize('files', filesUploaded.length)}`}</span> : undefined}
                  </div>
                </FontIcon>
              </CardHeader>
              <CardText expandable style={{ padding: '0' }}>
                <div className={`${classes.fileList}${Boolean(filesUploaded && filesUploaded.length) ? '' : ' hide' }${addYellow()}`}>
                  {filesUploaded.map((file, index) =>
                    <div
                      key={index}
                      className="element"
                    >
                        <span
                          onClick={() => this.removeAfile('filesUploaded')(index)}
                          className="remove"
                        >
                          x
                        </span>
                      <span
                        className="text"
                      >{file.name}</span>
                    </div>
                  )}
                </div>
                <Dropzone
                  className={`dropzone ${classes.dropZone2}${addYellow()}`}
                  onDrop={this.updateFileList('filesUploaded')}
                >
                  <FontIcon className="tc-icon-attach_file" color="#bfbfbf" style={{ fontSize: '14px', top: '2px', marginRight: '5px' }} />
                  Attach files by dragging & dropping, <span style={{ color: '#00b3cf', cursor: 'pointer' }}>selecting them</span>
                </Dropzone>
              </CardText>
            </Card>
            <UploadFromMM
              onChangeSelection={this.updateFileList('filesMM')}
              setClear={clear => this.clearMM = clear}
              onCardExpand={(MMExpanded) => this.setState({ MMExpanded })}
              style={{ ...styles.attachmentCard, borderBottom: 'none' }}
            />
          </div>
        </div>
      </div>
    );
  }
}


CommentBox.propTypes = {
  attachFile: PropTypes.func,
  borderless: PropTypes.bool,
  cancelComment: PropTypes.func,
  classes: PropTypes.object,
  className: PropTypes.string,
  comment: PropTypes.string,
  contractRequestWizard: PropTypes.object,
  disableSend: PropTypes.bool,
  focused: PropTypes.bool,
  handleInput: PropTypes.func,
  hideActions: PropTypes.bool,
  hideMesageBoxIcon: PropTypes.bool,
  hintText: PropTypes.string,
  internal: PropTypes.bool,
  isSupplier: PropTypes.bool,
  resetSelectedContractRequest: PropTypes.func,
  resetSelectedLocation: PropTypes.func,
  resetSelectedRate: PropTypes.func,
  setClear: PropTypes.func.isRequired,
  setFocus: PropTypes.func,
  setRates: PropTypes.func,
  submitComment: PropTypes.func,
  templateGroupSelected: PropTypes.object,
  templateOrGroup: PropTypes.string,
  templateSelected: PropTypes.object,
  receiverCompanyType: PropTypes.string,
};

CommentBox.defaultProps = {
  borderless: false,
  cancelComment: () => {},
  disableSend: false,
  hideActions: false,
  hideMesageBoxIcon: false,
  hintText: undefined,
  internal: false,
  setClear: () => {},
  setFocus: () => {},
  setRates: () => {},
};


// export default CommentBox;
const select = ({
  user,
  contracting: {
    supplierWizard,
    wizard,
  },
  partnerDetails: { files: currentRates },
}) => ({
  isSupplier: user.getIn(['user', 'type']) === 'Supplier',
  templateSelected: supplierWizard.get('templateSelected').toJS(),
  templateGroupSelected: supplierWizard.get('templateGroupSelected').toJS(),
  templateOrGroup: supplierWizard.get('sendTemplateOrGroup'),
  contractRequestWizard: wizard.toJS(),
  currentRates,
});

export default connect(select, {
  resetSelectedRate,
  resetSelectedLocation,
  resetSelectedContractRequest: resetSelectedContractRequestFn,
})(injectSheet(styles)(CommentBox));



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/comment-box.jsx